import { render, staticRenderFns } from "./MembershipManage.vue?vue&type=template&id=64bc9a7e&scoped=true"
import script from "./MembershipManage.vue?vue&type=script&lang=js"
export * from "./MembershipManage.vue?vue&type=script&lang=js"
import style0 from "./MembershipManage.vue?vue&type=style&index=0&id=64bc9a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc9a7e",
  null
  
)

export default component.exports